import _RentalForceBookApprovalService from "../services/rental-force-book-approval-service";
import { IRentalForceBookApprovalService } from "../types/services/rental-force-book-approval-service";

const RentalForceBookApprovalService: IRentalForceBookApprovalService = new _RentalForceBookApprovalService();

export default RentalForceBookApprovalService;
